export const MIN_TIME_RANGE = 3600 * 1000; // 1 hour

export function setWarning(label, input, button) {
  input.classList.add("input_field_warning");
  label.classList.add("label_title_warning");
  input.classList.remove("input_field_passed");
  label.classList.remove("label_title_passed");

  button.disabled = true;
}

export function removeWarning(label, input, button) {
  input.classList.remove("input_field_warning");
  label.classList.remove("label_title_warning");
  input.classList.add("input_field_passed");
  label.classList.add("label_title_passed");

  button.disabled = false;
}
